import { render } from "./CIS-Controls-Navigator-IG.vue?vue&type=template&id=8a93e37e&scoped=true"
import script from "./CIS-Controls-Navigator-IG.vue?vue&type=script&lang=js"
export * from "./CIS-Controls-Navigator-IG.vue?vue&type=script&lang=js"

import "./CIS-Controls-Navigator-IG.vue?vue&type=style&index=0&id=8a93e37e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a93e37e"]])

export default __exports__